@if (supplierId) {
  <app-admin-supplier-details [supplierId]="+supplierId" />
}
